// <!-- GRACE:MODULE_START name="ui_landing" -->
// <!-- GRACE:DEPENDENCY target="ui_auth" -->
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface HeaderProps {
  activePage: 'facts' | 'template' | 'dialog';
  onNavigate: (page: 'facts' | 'template' | 'dialog') => void;
}

// <!-- GRACE:CONTRACT function="Header" -->
export default function Header({ activePage, onNavigate }: HeaderProps) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="rounded-2xl border bg-white shadow-sm">
      <div className="flex items-center justify-between gap-3 px-4 py-3">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <div className="grid h-8 w-8 place-items-center rounded-xl bg-gray-900 text-xs font-bold text-white">
            Т
          </div>
          <span className="text-sm font-semibold">Толмач</span>
        </div>

        {/* Nav */}
        <nav className="hidden items-center gap-5 text-sm text-gray-600 md:flex">
          <button
            onClick={() => onNavigate('facts')}
            className={`hover:text-gray-900 ${
              activePage === 'facts' ? 'font-semibold text-gray-900' : ''
            }`}
          >
            Факты и Выводы
          </button>
          <button
            onClick={() => onNavigate('template')}
            className={`hover:text-gray-900 ${
              activePage === 'template' ? 'font-semibold text-gray-900' : ''
            }`}
          >
            Форматирование по шаблону
          </button>
          <button
            onClick={() => onNavigate('dialog')}
            className={`hover:text-gray-900 ${
              activePage === 'dialog' ? 'font-semibold text-gray-900' : ''
            }`}
          >
            Диалог по спикерам
          </button>
        </nav>

        {/* User menu */}
        <div className="flex items-center gap-2 text-sm">
          {user && (
            <span className="hidden text-gray-500 md:inline">{user.email}</span>
          )}
          <Link
            to="/change-password"
            className="rounded-lg border px-3 py-1.5 hover:bg-gray-50"
          >
            Сменить пароль
          </Link>
          <button
            onClick={handleLogout}
            className="rounded-lg bg-gray-900 px-3 py-1.5 font-medium text-white hover:bg-gray-800"
          >
            Выйти
          </button>
        </div>
      </div>

      {/* Mobile nav */}
      <div className="flex items-center gap-2 border-t px-4 py-2 text-sm md:hidden">
        <button
          onClick={() => onNavigate('facts')}
          className={`rounded-lg border px-3 py-1.5 ${
            activePage === 'facts' ? 'bg-gray-900 text-white' : ''
          }`}
        >
          Факты и Выводы
        </button>
        <button
          onClick={() => onNavigate('template')}
          className={`rounded-lg border px-3 py-1.5 ${
            activePage === 'template' ? 'bg-gray-900 text-white' : ''
          }`}
        >
          Форматирование по шаблону
        </button>
        <button
          onClick={() => onNavigate('dialog')}
          className={`rounded-lg border px-3 py-1.5 ${
            activePage === 'dialog' ? 'bg-gray-900 text-white' : ''
          }`}
        >
          Диалог по спикерам
        </button>
      </div>
    </div>
  );
}
// <!-- GRACE:MODULE_END name="ui_landing" -->
